// extracted by mini-css-extract-plugin
export default {"textWidth":"textWidth-33d4"};